/* Durnev — Size Guide picker.
   Two cascading dropdowns: category → subtype → variant panel.
   All variants pre-rendered in DOM; we toggle [hidden] on selection. */
class DurnevSizeGuide extends HTMLElement {
  connectedCallback() {
    this.variants = [...this.querySelectorAll('[data-variant]')].map(el => ({
      el,
      id: el.dataset.id,
      category: el.dataset.category,
      subtype: el.dataset.subtype,
    }));
    this.pickers = {
      category: this.querySelector('[data-picker="category"]'),
      subtype: this.querySelector('[data-picker="subtype"]'),
    };
    this.state = { category: null, subtype: null };

    Object.entries(this.pickers).forEach(([key, picker]) => {
      const btn = picker.querySelector('.durnev-sg__picker-btn');
      const menu = picker.querySelector('.durnev-sg__picker-menu');
      btn.addEventListener('click', () => this.toggleMenu(picker));
      menu.addEventListener('click', (e) => {
        const li = e.target.closest('li[data-value]');
        if (!li) return;
        this.pick(key, li.dataset.value);
        this.toggleMenu(picker, false);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        Object.values(this.pickers).forEach(p => this.toggleMenu(p, false));
      }
    });

    // Initialize: pick first visible variant
    if (this.variants.length > 0) {
      const first = this.variants.find(v => !v.el.hidden) || this.variants[0];
      this.pick('category', first.category);
      this.pick('subtype', first.subtype);
    }
  }

  toggleMenu(picker, force) {
    const btn = picker.querySelector('.durnev-sg__picker-btn');
    const menu = picker.querySelector('.durnev-sg__picker-menu');
    if (btn.disabled) return;
    const open = force === undefined ? menu.hidden : force;
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  pick(key, value) {
    this.state[key] = value;
    const picker = this.pickers[key];
    const valueEl = picker.querySelector('[data-role="value"]');
    valueEl.textContent = value;

    if (key === 'category') {
      // Refresh subtype options for this category
      const subtypes = [...new Set(
        this.variants.filter(v => v.category === value).map(v => v.subtype)
      )];
      const subtypeMenu = this.pickers.subtype.querySelector('.durnev-sg__picker-menu');
      subtypeMenu.innerHTML = subtypes
        .map(s => `<li role="option" data-value="${s.replace(/"/g, '&quot;')}">${s}</li>`)
        .join('');
      const subBtn = this.pickers.subtype.querySelector('.durnev-sg__picker-btn');
      subBtn.disabled = subtypes.length === 0;
      // Auto-pick first subtype to show something immediately
      if (subtypes.length > 0) {
        // If current subtype isn't valid for new category, switch to first
        if (!subtypes.includes(this.state.subtype)) {
          this.pick('subtype', subtypes[0]);
        } else {
          this.applyFilter();
        }
      } else {
        this.applyFilter();
      }
    } else {
      this.applyFilter();
    }
  }

  applyFilter() {
    const { category, subtype } = this.state;
    let matched = false;
    this.variants.forEach(v => {
      const show = v.category === category && v.subtype === subtype;
      v.el.hidden = !show;
      if (show) matched = true;
    });
    if (!matched && this.variants.length > 0) {
      // Fall back to first variant of the category
      const first = this.variants.find(v => v.category === category) || this.variants[0];
      this.variants.forEach(v => (v.el.hidden = v !== first));
    }
  }
}
customElements.define('durnev-size-guide', DurnevSizeGuide);
